import React, { ComponentProps } from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { Stack, styled } from '@mui/material'

import { ProductCarouselContext } from './ProductCarouselContext'

export type ProductCarouselThumbListProps = ComponentProps<typeof Stack> & {
  children: React.ReactNode
  direction?: 'row' | 'column'
}

export const ProductCarouselThumbList: React.FC<ProductCarouselThumbListProps> = ({ children, direction = 'column', ...props }) => {
  const { thumblistRef } = React.useContext(ProductCarouselContext)

  return (
    <StyledStack 
      ref={thumblistRef} 
      direction={direction}
      spacing={0}
      {...props}
    >
      {children}
    </StyledStack>
  )
}

export const StyledStack = styled(Stack)`
  position: relative;
  display: ${props => props.direction === 'column' ? 'none' : 'flex'};
  width: 100%;
  padding: 0 ${props => props.direction === 'column' ? 0 : pxToRem(16)};
  scroll-behavior: smooth;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: visible;
  margin-top: ${pxToRem(8)};
  
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    display: ${props => props.direction === 'column' ? 'unset' : 'none'};
    flex-direction: column;
    width: ${pxToRem(72)};
    height: ${pxToRem(560, 0.8)};
    overflow-y: auto;
    overflow-x: visible;
  }
`